<div class="page">
  <div class="page-header">
    <ssg-select
      name="Goods"
      [label]="'ClientApp.FrontOffice.Inv.DailyUsage.StockItem' | translate"
      [group]="formGroup"
      apiName="SaleFormula/GetAnalysisGoodsForUsagePaging"
      valueFieldName="Id"
      textFieldName="Title"
      textColumnsName="Title,Code,UnitTitle"
      filterKey="Title,Code"
      [columnsTitleName]="'ClientApp.FrontOffice.Inv.DailyUsage.Unit' | translate"
      userClass="select-md"
      [isMultiColumns]="true"
      SortColumn="Code">
    </ssg-select>
    <ng-container *ngIf="isMultiBranch">
      <ssg-select
        [group]="formGroup"
        name="BranchId"
        apiName="Branch/ReadBranchLookUp"
        [label]="'General.Branch' | translate"
        valueFieldName="Id"
        textFieldName="Title"
        [required]="true">
      </ssg-select>
    </ng-container>
    <ssg-button
      class="get-data"
      type="button"
      (click)="getData()"
      [label]="'ClientApp.FrontOffice.Inv.DailyUsage.UploadInformation' | translate"></ssg-button>
  </div>
  <kgrid
    class="grid"
    [isAdd]="false"
    (onRefreshData)="getData()"
    [noToolBar]="true"
    [columns]="columns"
    [dataList]="itemLists"
    pathPreFix="SALE"></kgrid>
</div>
